import React from 'react';
import {injectIntl} from 'react-intl';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildPieChartOptions = (config, data, hints, intl) => {
    const sum = data.series.map((s) => s.values.reduce((a, b) => a + b, 0));

    return fillChartOptions({
        chart: {
            type: 'pie',
        },
        colors: ['#119BD6', '#F9C717', '#E8617F', '#B6B6B5'],
        legend: {
            enabled: true,
        },
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%'],
                size: '110%',
            },
        },
        tooltip: {
            formatter: function() {
                return `${this.key}: ${this.y}${hints.absolute ? '' : '%'}`;
            },
        },
        series: data.series.map((s, i) => ({
            name: s.name,
            showInLegend: true,
            data: data.categories.map((category, j) => ({
                name: category,
                y: percentualize(data.series[i].values[j], sum[i], hints),
            })),
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '<b>{point.name}</b>: {point.y}' : '<b>{point.name}</b>: {point.y:.1f}%',
            },
            innerSize: '50%',
        })),
    }, config, data, hints, intl);
};

const builders = {
    pie: buildPieChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.column(config, data, hints, intl);
};

const GeneratorSentimentAnalysis = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />
);

export default injectIntl(GeneratorSentimentAnalysis);
